import {createStore} from "vuex"

function encrypt(data, key, useSessionStorage = false){

    try {
        data = btoa(JSON.stringify(data))
        if(useSessionStorage){
            sessionStorage.setItem(key, data)
            return sessionStorage.getItem(key)
        }

        localStorage.setItem(key, data)
        return localStorage.getItem(key)
    }
    catch(err) {
        if(useSessionStorage){
            sessionStorage.setItem('vault-pay-access-token', null);
            sessionStorage.clear();
        }else{
            localStorage.setItem('vault-pay-access-token', null);
            localStorage.clear();
        }
        let cookieName = 'PHPSESSID'
        let cookieValue = "";
        let cookieLifetime = -1;
        var date = new Date();
        date.setTime(date.getTime()+(cookieLifetime*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
        document.cookie = cookieName+"="+JSON.stringify(cookieValue)+expires+"; path=/";
    }


}

function decrypt(data, useSessionStorage = false){
    if(data){
        try {
            data = atob(data)
            return JSON.parse(data)
        }
        catch(err) {
            if(useSessionStorage){
                sessionStorage.setItem('vault-pay-access-token', null);
                sessionStorage.clear();
            }else{
                localStorage.setItem('vault-pay-access-token', null);
                localStorage.clear();
            }
            let cookieName = 'PHPSESSID'
            let cookieValue = "";
            let cookieLifetime = -1;
            var date = new Date();
            date.setTime(date.getTime()+(cookieLifetime*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
            document.cookie = cookieName+"="+JSON.stringify(cookieValue)+expires+"; path=/";
        }

    }

}

const store = createStore({
    state: {
        currency: null,
        userGeneralInfo: typeof (localStorage.getItem('userGeneralInfo')) != "undefined" && (localStorage.getItem('userGeneralInfo')) != null ? decrypt(localStorage.getItem('userGeneralInfo')) : null,
        userEmailOrPhone: typeof (localStorage.getItem('userEmailOrPhone')) != "undefined" && (localStorage.getItem('userEmailOrPhone')) != null ? decrypt(localStorage.getItem('userEmailOrPhone')) : null,
        userSendMoneyHash: typeof (localStorage.getItem('userSendMoneyHash')) != "undefined" && (localStorage.getItem('userSendMoneyHash')) != null ? decrypt(localStorage.getItem('userSendMoneyHash')) : null,
        balanceLimitHash: typeof (localStorage.getItem('balanceLimitHash')) != "undefined" && (localStorage.getItem('balanceLimitHash')) != null ? decrypt(localStorage.getItem('balanceLimitHash')) : null,
        userSendMoneyAmount: typeof (localStorage.getItem('userSendMoneyAmount')) != "undefined" && (localStorage.getItem('userSendMoneyAmount')) != null ? decrypt(localStorage.getItem('userSendMoneyAmount')) : null,
        loggedInUser: typeof (localStorage.getItem('merchantLoggedInUser')) != "undefined" && (localStorage.getItem('merchantLoggedInUser')) != null ? decrypt(localStorage.getItem('merchantLoggedInUser')) : null,
        accountData: typeof (localStorage.getItem('accountData')) != "undefined" && (localStorage.getItem('accountData')) != null ? decrypt(localStorage.getItem('accountData')) : null,
        userRequestSendMoneyData: typeof (localStorage.getItem('userRequestSendMoneyData')) != "undefined" && (localStorage.getItem('userRequestSendMoneyData')) != null ? decrypt(localStorage.getItem('userRequestSendMoneyData')) : null,
        userRequestSendMoneyHash: typeof (localStorage.getItem('userRequestSendMoneyHash')) != "undefined" && (localStorage.getItem('userRequestSendMoneyHash')) != null ? decrypt(localStorage.getItem('userRequestSendMoneyHash')) : null,
        dashboardFeatures: typeof (localStorage.getItem('merchantDashboardFeatures')) != "undefined" && (localStorage.getItem('merchantDashboardFeatures')) != null ? decrypt(localStorage.getItem('merchantDashboardFeatures')) : null,
        updateStaffData: typeof (localStorage.getItem('updateStaffData')) != "undefined" && (localStorage.getItem('updateStaffData')) != null ? decrypt(localStorage.getItem('updateStaffData')) : null,
        transactionDetail: typeof (localStorage.getItem('transactionDetail')) != "undefined" && (localStorage.getItem('transactionDetail')) != null ? decrypt(localStorage.getItem('transactionDetail')) : null,
        paymentLinkDetail: typeof (localStorage.getItem('paymentLinkDetail')) != "undefined" && (localStorage.getItem('paymentLinkDetail')) != null ? decrypt(localStorage.getItem('paymentLinkDetail')) : null,
        resetType: typeof (localStorage.getItem('resetType')) != "undefined" && (localStorage.getItem('resetType')) != null ? decrypt(localStorage.getItem('resetType')) : null,
        settlementData: typeof (localStorage.getItem('settlementData')) != "undefined" && (localStorage.getItem('settlementData')) != null ? decrypt(localStorage.getItem('settlementData')) : null,
        paymentLinkLogsData: null,
        walletAccount: null,
        userProfilePicture:typeof (localStorage.getItem('userProfilePicture')) != "undefined" && (localStorage.getItem('userProfilePicture')) != null && localStorage.getItem('userProfilePicture') ? localStorage.getItem('userProfilePicture')  : process.env.BASE_URL+'images/avatar/avatar-user.png',
        excelLoader:false,
        pdfLoader:false,
        logoutPopup:false,
        chosenPage:1,
        chosenPerPage:10,
        currentStoreActivation: null,
        posChannelData: typeof (localStorage.getItem('posChannelData')) != "undefined" && (localStorage.getItem('posChannelData')) != null ? decrypt(localStorage.getItem('posChannelData')) : null,
    },
    getters: {
        getByKey: (state) => (key) => {
            if(typeof (state[key]) != 'undefined'){
                return JSON.parse(state[key])
            }else{
                return null
            }
        },
        /* for reset pin and password type*/
        getResetType(state) {
            return state.resetType
        },
        /*settlement data*/
        getSettlementData(state) {
            return state.settlementData
        },
        getCurrencyData(state) {
            return state.currency
        },
        getLoggedInUser(state) {
            return state.loggedInUser
        },
        isPayfacMerchant(state) {
            return state.loggedInUser?.is_payfac_merchant == 1
        },
        isSubMerchant(state) {
            return state.loggedInUser?.sub_merchant == 1
        },
        getAccountData(state) {
            return state.accountData
        },
        /*
        |--------------------------------------------------------------------------
        | Send Money Api Store Getter
        |--------------------------------------------------------------------------
        |
        | Register Your Send Money Getter Here
        |
        */

        // send money data getter starts
        getUserGeneralInfoData(state) {
            return state.userGeneralInfo
        },
        getUserEmailOrPhoneData(state) {
            return state.userEmailOrPhone
        },
        getUserSendMoneyHash(state) {
            return state.userSendMoneyHash
        },
        getUserSendMoneyAmount(state) {
            return state.userSendMoneyAmount
        },
        // send money data getter ends

        /*
         |--------------------------------------------------------------------------
         | Request Money Api Store Getter
         |--------------------------------------------------------------------------
         |
         | Register Your Request Money Getter Here
         |
         */

        // request money data getter starts
        getUserRequestSendMoneyData(state) {
            return state.userRequestSendMoneyData
        },
        getUserRequestSendMoneyHash(state) {
            return state.userRequestSendMoneyHash
        },
        // request money data getter ends


        /*
        |--------------------------------------------------------------------------
        | Deposit Money Api Store Getter
        |--------------------------------------------------------------------------
        |
        | Register Your Deposit Money Getter Here
        |
        */

        // deposit money data getter starts
        getBalanceLimitHash(state) {
            return state.balanceLimitHash
        },
        // deposit money data getter ends

        /*
        |--------------------------------------------------------------------------
        | Dashboard Feature Api Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Dashboard Feature Getters Here
        |
        */

        // dashboard features data getter starts
        getDashboardFeatures(state) {
            return state.dashboardFeatures
        },
        // dashboard features data getter ends

        /*
        |--------------------------------------------------------------------------
        | Update Staff Data Api Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Update Staff Data Getters Here
        |
        */

        // updateStaffData data getter starts
        getUpdateStaffData(state) {
            return state.updateStaffData
        },
        // updateStaffData data getter ends


        /*
        |--------------------------------------------------------------------------
        | Transaction Detail Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Transaction Detail Getters Here
        |
        */

        // transactionDetail data getter starts
        getTransactionDetail(state) {
            return state.transactionDetail
        },
        // transactionDetail data getter ends


        /*
        |--------------------------------------------------------------------------
        | Payment LinkDetail Store Getters
        |--------------------------------------------------------------------------
        |
        | Register Your Payment LinkDetail Getters Here
        |
        */

        // paymentLinkDetail data getter starts
        getPaymentLinkDetail(state) {
            return state.paymentLinkDetail
        },
        // paymentLinkDetail data getter ends

        //paymentLinkLogsData  data getter starts
        getPaymentLinkLogsData(state) {
            return JSON.parse(state.paymentLinkLogsData)
        },
        // paymentLinkLogsData data getter ends

        getChosenPage(state) {
            return state.chosenPage
        },
        getChosenPerPage(state) {
            return state.chosenPerPage
        },
        getCurrentStoreActivation(state) {
            return state.currentStoreActivation
        },
        getPosChannelData(state) {
            return state.posChannelData
        },


    },

    // Mutation for when you use it as state property
    mutations: {
        set(state, payload) {
            if (payload) {
                localStorage.setItem(payload.key, JSON.stringify(payload))
                state[payload.key] = localStorage.getItem(payload.key);
            }
        },
        /*for reset pin and password*/
        setResetType(state, data) {
            data = encrypt(data, 'resetType')
            state.resetType = decrypt(data)
        },
        /*settlement data*/
        setSetSettlementData(state, data) {
            data = encrypt(data, 'settlementData')
            state.settlementData = decrypt(data)
        },
        setCurrencyData(state, data) {
            state.currency = data;
        },
        setLoggedInUser(state, data) {
            data = encrypt(data, 'merchantLoggedInUser')
            state.loggedInUser = decrypt(data)
        },
        setAccountData(state, data) {
            data = encrypt(data, 'accountData')
            state.accountData = decrypt(data)
        },
        /*
       |--------------------------------------------------------------------------
       | Send Money Api Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Send Money Mutations Here
       |
       */

        // send money data mutations starts
        setUserGeneralInfoData(state, data) {
            data = encrypt(data, 'userGeneralInfo')
            state.userGeneralInfo = decrypt(data)
        },
        setUserEmailOrPhoneData(state, data) {
            data = encrypt(data, 'userEmailOrPhone')
            state.userEmailOrPhone = decrypt(data)
        },
        setUserSendMoneyHash(state, data) {
            data = encrypt(data, 'userSendMoneyHash')
            state.userSendMoneyHash = decrypt(data)
        },
        setUserSendMoneyAmount(state, data) {
            data = encrypt(data, 'userSendMoneyAmount')
            state.userSendMoneyAmount = decrypt(data)
        },
        // send money data mutations ends


        /*
         |--------------------------------------------------------------------------
         | Request Money Api Store Mutations
         |--------------------------------------------------------------------------
         |
         | Register Your Request Money Mutations Here
         |
         */

        // request money data mutations starts
        setUserRequestSendMoneyData(state, data) {
            data = encrypt(data, 'userRequestSendMoneyData')
            state.userRequestSendMoneyData = decrypt(data)
        },
        setUserRequestSendMoneyHash(state, data) {
            data = encrypt(data, 'userRequestSendMoneyHash')
            state.userRequestSendMoneyHash = decrypt(data)
        },
        // request money data mutations ends


        /*
      |--------------------------------------------------------------------------
      | Deposit Money Api Store Mutations
      |--------------------------------------------------------------------------
      |
      | Register Your Deposit Money Mutations Here
      |
      */

        // deposit money data mutations starts
        setBalanceLimitHash(state, data) {
            data = encrypt(data, 'balanceLimitHash')
            state.balanceLimitHash = decrypt(data)
        },
        // deposit money data mutations ends

        /*
      |--------------------------------------------------------------------------
      | Dashboard Feature Api Store Mutations
      |--------------------------------------------------------------------------
      |
      | Register Your Dashboard Feature Mutations Here
      |
      */
        // dashboard features data mutations starts
        setDashboardFeatures(state, data) {
            data = encrypt(data, 'merchantDashboardFeatures',true)
            state.dashboardFeatures = decrypt(data,true)
        },
        // dashboard features data mutations ends

        /*
       |--------------------------------------------------------------------------
       | Update Staff Data Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Update Staff Data Mutations Here
       |
       */
        // update Staff data mutations starts
        setUpdateStaffData(state, data) {
            data = encrypt(data, 'updateStaffData')
            state.updateStaffData = decrypt(data)
        },
        // update Staff data mutations ends


        /*
       |--------------------------------------------------------------------------
       | Transaction Detail Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Transaction Detail Mutations Here
       |
       */
        // transactionDetail mutations starts
        setTransactionDetail(state, data) {
            data = encrypt(data, 'transactionDetail')
            state.transactionDetail = decrypt(data)
        },
        // transactionDetail mutations ends



        /*
       |--------------------------------------------------------------------------
       | Payment LinkDetail Store Mutations
       |--------------------------------------------------------------------------
       |
       | Register Your Payment LinkDetail Mutations Here
       |
       */
        // paymentLinkDetail mutations starts
        setPaymentLinkDetail(state, data) {

            data = encrypt(data, 'paymentLinkDetail')
            state.paymentLinkDetail = decrypt(data)

        },
        // paymentLinkDetail mutations ends

        // paymentLinkLogsData mutations starts
        setPaymentLinkLogsData(state, data) {

            state.paymentLinkLogsData = JSON.stringify(data)
            // if (payload) {
            //
            // }
            // data = encrypt(data, 'paymentLinkLogsData')
            // state.paymentLinkLogsData = decrypt(data)

        },
        // paymentLinkLogsData mutations ends

        setWalletAccount(state, payload) {
            state.walletAccount = payload
        },

        setUserProfilePicture(state, payload) {
            localStorage.setItem('userProfilePicture',payload);
            // state.userProfilePicture = localStorage.getItem('userProfilePicture');
            state.userProfilePicture = new Date().getTime() / 1000;

        },
        setExcelLoader(state, payload) {
            state.excelLoader = payload
        },
        setPdfLoader(state, payload) {
            state.pdfLoader = payload
        },
        setLogoutPopup(state, payload) {
            state.logoutPopup = payload
        },
        setChosenPage(state, payload) {
            state.chosenPage = payload
        },
        setChosenPerPage(state, payload) {
            state.chosenPerPage = payload
        },
        setCurrentStoreActivation(state, payload) {
            state.currentStoreActivation = payload
        },
        setPosChannelData(state, payload) {
            payload = encrypt(payload, 'posChannelData')
            state.posChannelData = decrypt(payload)
        },
        setWithoutLocalStorage(state, payload) {
            if (payload) {
                state[payload.key] = JSON.stringify(payload)
            }
        },





    },
    actions: {
        set(context, payload) {
            context.commit('set', payload)
        },
        updateWalletAccount(context, payload) {
            context.commit('setWalletAccount', payload)
        },
        updateUserProfilePicture(context, payload) {
            context.commit('setUserProfilePicture', payload)
        },
        exportExcelLoader(context, payload) {
            context.commit('setExcelLoader', payload)
        },
        exportPdfLoader(context, payload) {
            context.commit('setPdfLoader', payload)
        },

        showLogoutPopup(context,payload){
            context.commit('setLogoutPopup',payload)
        },
        setWithoutLocalStorage(context, payload) {
            context.commit('setWithoutLocalStorage', payload)
        },
    }
})

export default store
